import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { TamasAlunoService } from "../tamas-aluno.service";
import { AlertaSimplesDialog } from "../alerta-simples";
import { AlertaInputDialog } from "../alerta-input";
import { AlertaConfirmDialog } from "../alerta-confirm";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import * as moment from "moment";

@Component({
  selector: "app-me-perfil",
  templateUrl: "./me-perfil.component.html",
  styleUrls: ["./me-perfil.component.css"],
})
export class MePerfilComponent implements OnInit, OnDestroy {
  hideCL: boolean = false;
  meuNome: any = "";
  meuNick: any = "";
  dataNascimento: any = "";
  altura: any = "";
  peso: any = "";
  meuLocal: any = "";
  minhaFoto: any = "";
  meuCelular: any = "";
  minhaFrase: any = "";
  urlFoto: any = "";
  constructor(
    private route: ActivatedRoute,
    private _location: Location,
    public router: Router,
    public tmaService: TamasAlunoService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.buscarMeuPerfil();
    this.tmaService.eventoFS(true);
  }

  ngOnDestroy() {
    console.log("destroy");
    this.tmaService.eventoFS(false);
  }
  buscarMeuPerfil(): void {
    //server side
    this.hideCL = false;
    var dadosIn =
      "email=" + this.tmaService.hcEmail + "&senha=" + this.tmaService.hcSenha;
    this.tmaService.listarPerfilFull(dadosIn).subscribe((qRes) => {
      console.log(qRes);
      if (qRes["res"] == "done") {
        this.urlFoto =
          this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
        this.meuNome = qRes["dadosUsuario"].nome;
        this.meuNick = qRes["dadosUsuario"].nickname;
        this.dataNascimento = moment(qRes["dadosUsuario"].nascimento).format(
          "DD/MM/YYYY"
        );
        //this.altura = qRes['dadosUsuario'].altura.toFixed(2);
        this.altura = qRes["dadosUsuario"].altura;
        this.peso = qRes["dadosUsuario"].peso;
        this.meuLocal =
          qRes["dadosUsuario"].cidade + "/" + qRes["dadosUsuario"].uf;
        this.minhaFoto = qRes["dadosUsuario"].fotoPerfil;
        this.meuCelular = qRes["dadosUsuario"].celular;
        this.minhaFrase = qRes["dadosUsuario"].frasebio;
      } else {
        //algo errado
      }
      this.hideCL = true;
    });
  }
  goEdit(tipoP: any): void {
    if (tipoP == "modalidades") {
      this.tmaService.gUrlAnterior = "me/perfil";
      this.router.navigate(["/" + this.tmaService.hcNomeUsuario + "/" + tipoP]);
    } else if (tipoP == "conquistas") {
      this.tmaService.gUrlAnterior = "me/perfil";
      this.router.navigate(["/" + this.tmaService.hcNomeUsuario + "/" + tipoP]);
    } else if (tipoP == "localizacao") {
      this.tmaService.gUrlAnterior = "me/perfil";
      this.router.navigate(["/me/perfil/local"]);
    } else if (tipoP == "foto") {
      this.tmaService.gUrlAnterior = "me/perfil";
      this.router.navigate(["/me/perfil/foto"]);
    } else if (tipoP == "locais") {
      this.tmaService.gUrlAnterior = "me/perfil";
      this.router.navigate(["/" + this.tmaService.hcNomeUsuario + "/" + tipoP]);
    } else if (tipoP == "profissionais") {
      this.tmaService.gUrlAnterior = "me/perfil";
      this.router.navigate(["/" + this.tmaService.hcNomeUsuario + "/" + tipoP]);
    } else {
      const atendimentOffDialog = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: "Opss...", iconAlerta: "warning" },
      });
    }
  }

  inputNick(nick: any) {
    const novoAlertaIn = this.dialog.open(AlertaInputDialog, {
      disableClose: true,
      data: {
        tituloAlerta: "Alterar nome de usuário ",
        textoAlerta: "Altere o valor no campo abaixo e clique em Salvar",
        tipoInput: "text",
        textoCancel: "cancelar",
        textoConfirm: "Salvar",
        valorInput: nick,
        nomeInput: "nick",
        beFocused: true,
      },
    });
    novoAlertaIn.afterClosed().subscribe((result) => {
      console.log(result);
      if (result !== false) {
        this.hideCL = false;
        // console.log(result + ' ' + tipoE);
        var dadosIn =
          "meunick=" +
          result +
          "&email=" +
          this.tmaService.hcEmail +
          "&senha=" +
          this.tmaService.hcSenha;
        this.tmaService.altUsuarioNick(dadosIn).subscribe((qRes) => {
          console.log(qRes);
          this.hideCL = true;
          if (qRes["res"] == "done") {
            this.buscarMeuPerfil();
          } else {
            const atendimentOffDialog = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: {
                textoAlerta:
                  "Desculpe, o nome de usuário: <b>" +
                  result +
                  "</b> já está sendo utilizado por outra pessoa<br>",
                iconAlerta: "warning",
              },
            });
          }
        });
      }
    });
  }

  inpEdit(tipoE: any, valE: any) {
    const novoAlertaIn = this.dialog.open(AlertaInputDialog, {
      disableClose: true,
      data: {
        tituloAlerta: "Editando " + tipoE,
        textoAlerta: "Altere o valor no campo abaixo e clique em Salvar",
        tipoInput: "tel",
        textoCancel: "cancelar",
        textoConfirm: "Salvar",
        valorInput: valE,
        nomeInput: tipoE,
        beFocused: true,
      },
    });
    novoAlertaIn.afterClosed().subscribe((result) => {
      if (result !== false) {
        //enviar para servidor e atualizar valores
        this.hideCL = false;
        console.log(result + " " + tipoE);

        if (tipoE == "altura") {
          result = result.toString().replace(".", "").replace(",", ".");
        }
        if (tipoE == "peso") {
          result = result
            .toString()
            .replace(".", ",")
            .replace("kg", "")
            .replace("k", "")
            .replace("kilos", "")
            .replace("quilos", "");
        }

        //var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&tipodado=' + tipoE + '&valordado=' + result;

        let customParams = {
          //lista: localStorage.getItem('turboCart'),
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
          tipodado: tipoE,
          valordado: result,
        };

        this.tmaService.editarDadoPerfil(customParams).subscribe((qRes) => {
          this.hideCL = true;
          console.log(qRes);
          if (qRes["res"] == "done") {
            if (tipoE == "nascimento") {
              this.dataNascimento = result;
            }
            if (tipoE == "altura") {
              this.altura = result;
            }
            if (tipoE == "peso") {
              this.peso = result;
            }
            if (tipoE == "celular") {
              this.meuCelular = result;
            }
            if (tipoE == "nome") {
              this.meuNome = result;
            }
            if (tipoE == "frase") {
              this.minhaFrase = result;
            }
          }
        });
      }
    });
  }
  share() {
    // this.ngNavigatorShareService.share({
    //   title: 'Perfil de ' + this.meuNome,
    //   text: 'Ei olha o meu perfil no Tamas',
    //   url: 'https://apptamasaluno.web.app/' + this.meuNick
    // }).then( (response) => {
    //   console.log(response);
    // })
    // .catch( (error) => {
    //   console.log(error);
    // });
  }

  goPerfil(nomeUser: any): void {
    this.tmaService.gUrlAnterior = this.router.url;
    this.router.navigate(["/" + nomeUser]);
  }

  goSettings(): void {
    console.log("settings");
    this.tmaService.gUrlAnterior = "me/perfil";
    this.router.navigate(["/me/settings"]);
  }
  logout(): void {
    const avisoIC = this.dialog.open(AlertaConfirmDialog, {
      // width: '250px',
      disableClose: true,
      data: {
        tituloAlerta: "Aviso",
        textoAlerta: "Desja efetuar o logout?",
        textoCancel: "Não",
        textoConfirm: "Sim",
      },
    });
    avisoIC.afterClosed().subscribe((result) => {
      console.log(result);
      if (result == true) {
        this.tmaService.hcEmail = "";
        this.tmaService.hcSenha = "";
        this.tmaService.hcNomeUsuario = "";
        this.tmaService.logado = false;
        localStorage.removeItem("tmsDadosCliente");
        this.router.navigate(["/autenticar"]);
      }
    });
    console.log("sair");
  }

  voltar(): void {
    console.log(this.tmaService.gUrlAnterior);
    if (this.tmaService.gUrlAnterior == "") {
      this.router.navigate(["/home"]);
    } else {
      //this._location.back();
      if (this.tmaService.gUrlAnterior == "me/perfil") {
        this.router.navigate(["/home"]);
      } else {
        this.router.navigate([this.tmaService.gUrlAnterior]);
      }
    }
  }
}
